// extracted by mini-css-extract-plugin
export default {"imgdiv":"a9c3114f9f _2236ce6dd5","img":"_2f6689684b _3f2d9d6fcb"};